class VehicleModelSelector extends HTMLElement {
  constructor() {
    super();
    // console.log('VehicleModelSelector initialized');
    this.mql = window.matchMedia('(min-width: 990px)');
    this.elements = {
      vehicleButton: this.querySelector('.disclosure__button'),
      vehiclePanel: this.querySelector('.disclosure__list-wrapper'),
      search: this.querySelector('input[name="vehicle_filter"]'),
      closeButton: this.querySelector('.vehicle-filter__reset-button'),
      vehicleOptions: this.querySelectorAll('#vehicle-model-list .disclosure__item button'),
      generationSelector: this.querySelector('.generation-selector'),
      generationButton: this.querySelector('.generation-selector .disclosure__button'),
      generationPanel: this.querySelector('.generation-selector .disclosure__list-wrapper'),
      generationList: this.querySelector('#generation-list'),
    };
    this.addEventListeners();
  }

  addEventListeners() {
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
    this.elements.vehicleButton.addEventListener('click', this.toggleSelector.bind(this, 'vehicle'));
    this.elements.generationButton.addEventListener('click', this.toggleSelector.bind(this, 'generation'));

    this.elements.vehicleOptions.forEach((option) => {
      option.addEventListener('click', this.onVehicleItemClick.bind(this));
    });

    if (this.elements.search) {
      this.elements.search.addEventListener('keyup', this.filterOptions.bind(this));
      this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
    }

    if (this.elements.closeButton) {
      this.elements.closeButton.addEventListener('click', this.closeModal.bind(this));
    }

    document.addEventListener('click', this.handleOutsideClick.bind(this));
  }

  handleOutsideClick(event) {
    if (!this.contains(event.target)) {
      this.hidePanel('vehicle');
      this.hidePanel('generation');
    }
  }

  onContainerKeyDown(event) {
    const focusableItems = Array.from(this.querySelectorAll('button.disclosure__link:not([hidden])'));
    let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
    let itemToFocus;

    switch (event.code.toUpperCase()) {
      case 'ARROWUP':
        event.preventDefault();
        itemToFocus =
          focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
        itemToFocus.focus();
        break;
      case 'ARROWDOWN':
        event.preventDefault();
        itemToFocus =
          focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
        itemToFocus.focus();
        break;
      case 'ENTER':
        event.preventDefault();
        if (focusedItemIndex > -1) {
          this.onItemClick({ target: focusableItems[focusedItemIndex] });
        }
        break;
    }

    if (this.elements.search) {
      setTimeout(() => {
        focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        if (focusedItemIndex > -1) {
          this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
        } else {
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
      });
    }
  }

  onContainerKeyUp(event) {
    event.preventDefault();

    switch (event.code.toUpperCase()) {
      case 'ESCAPE':
        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
        break;
      case 'SPACE':
        if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
        this.toggleSelector();
        break;
    }
  }

  toggleSelector(type, event) {
    if (event) {
      event.stopPropagation();
    }
    const button = type === 'vehicle' ? this.elements.vehicleButton : this.elements.generationButton;
    const panel = type === 'vehicle' ? this.elements.vehiclePanel : this.elements.generationPanel;
    const isExpanded = button.getAttribute('aria-expanded') === 'true';

    panel.toggleAttribute('hidden', isExpanded);
    button.setAttribute('aria-expanded', !isExpanded);

    if (!isExpanded && type === 'vehicle' && this.elements.search && this.mql.matches) {
      this.elements.search.focus();
    }
  }

  filterOptions() {
    const searchValue = this.elements.search.value.toLowerCase().trim();
    const searchRegex = new RegExp(searchValue, 'i');
    const options = this.querySelectorAll('.disclosure__item');
    let visibleOptions = 0;

    options.forEach((option) => {
      const optionLink = option.querySelector('button.disclosure__link');
      const optionText = optionLink.textContent.toLowerCase().trim();
      const isMatch = searchRegex.test(optionText);

      option.style.display = isMatch ? '' : 'none';
      if (isMatch) {
        visibleOptions++;
      }
    });
  }

  closeModal(event) {
    event.preventDefault();
    event.stopPropagation();
    this.hidePanel('vehicle');
    this.hidePanel('generation');
  }

  hidePanel(type) {
    const button = type === 'vehicle' ? this.elements.vehicleButton : this.elements.generationButton;
    const panel = type === 'vehicle' ? this.elements.vehiclePanel : this.elements.generationPanel;
    button.setAttribute('aria-expanded', 'false');
    panel.setAttribute('hidden', true);
  }

  onSearchKeyDown(event) {
    if (event.code.toUpperCase() === 'ENTER') {
      event.preventDefault();
    }
  }

  onVehicleItemClick(event) {
    const target = event.target;
    const selectedValue = target.dataset.value;
    const selectedVehicleSize = target.dataset.vehicleSize;
    const generationData = target.dataset.generation;

    // Clear previous selections
    this.querySelectorAll('.disclosure__link[aria-selected="true"]').forEach((button) => {
      button.setAttribute('aria-selected', 'false');
    });

    // Set current selection
    target.setAttribute('aria-selected', 'true');

    this.elements.vehicleButton.querySelector('span').textContent = target.textContent;
    this.hidePanel('vehicle');

    // console.log('Vehicle item clicked:', { selectedValue, selectedVehicleSize, generationData });

    // Update Shopify's variant selector (radio buttons)
    const variantRadios = document.querySelectorAll('input[type="radio"]');
    const matchingVariant = Array.from(variantRadios).find(
      (radio) => this.handleize(radio.value) === this.handleize(selectedVehicleSize)
    );

    if (matchingVariant) {
      matchingVariant.checked = true;
      matchingVariant.dispatchEvent(new Event('change', { bubbles: true }));
      // console.log('Updated variant selection:', matchingVariant.value);
    } else {
      console.warn('Matching variant radio button not found');
    }

    // Handle generation data
    if (generationData) {
      this.populateGenerationDropdown(generationData);
    } else {
      this.hideGenerationDropdown();
    }

    // Dispatch a custom event for vehicle selection
    this.dispatchEvent(
      new CustomEvent('vehicleSelected', {
        bubbles: true,
        detail: {
          value: selectedValue,
          vehicleSize: selectedVehicleSize,
          generation: generationData ? '' : undefined,
        },
      })
    );
  }

  populateGenerationDropdown(generationData) {
    const generations = generationData.split(',').map((gen) => gen.trim());
    this.elements.generationList.innerHTML = '';
    generations.forEach((gen) => {
      const li = document.createElement('li');
      li.className = 'disclosure__item';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'disclosure__link uppercase';
      button.setAttribute('role', 'option');
      button.setAttribute('aria-selected', 'false');
      button.textContent = gen;
      button.addEventListener('click', this.onGenerationItemClick.bind(this));
      li.appendChild(button);
      this.elements.generationList.appendChild(li);
    });

    // Show the generation selector
    this.elements.generationSelector.style.display = 'block';

    // Auto-select if only one generation option
    if (generations.length === 1) {
      const singleGeneration = generations[0];
      this.elements.generationButton.querySelector('span').textContent = singleGeneration;

      // Set the first (and only) generation button as selected
      const firstGenerationButton = this.elements.generationList.querySelector('button');
      if (firstGenerationButton) {
        firstGenerationButton.setAttribute('aria-selected', 'true');
      }

      // Use setTimeout to ensure form listeners are ready
      setTimeout(() => {
        // Dispatch the generation selection event
        console.log('Auto-selecting generation:', singleGeneration);
        this.dispatchEvent(
          new CustomEvent('generationSelected', {
            bubbles: true,
            detail: {
              generation: singleGeneration,
            },
          })
        );
      }, 100);

      // Optionally hide the dropdown since there's only one option
      // Uncomment the next line if you want to hide it completely
      // this.elements.generationSelector.style.display = 'none';
    }
  }

  hideGenerationDropdown() {
    // Clear any selected generation buttons
    this.elements.generationList.querySelectorAll('button[aria-selected="true"]').forEach((button) => {
      button.setAttribute('aria-selected', 'false');
    });

    this.elements.generationSelector.style.display = 'none';
    this.elements.generationList.innerHTML = '';
    this.elements.generationButton.querySelector('span').textContent = 'Select Generation';

    // Dispatch a custom event to indicate that generation is cleared
    this.dispatchEvent(
      new CustomEvent('generationSelected', {
        bubbles: true,
        detail: {
          generation: '',
        },
      })
    );
  }

  onGenerationItemClick(event) {
    const selectedGeneration = event.target.textContent;

    // Clear previous generation selections
    this.elements.generationList.querySelectorAll('button[aria-selected="true"]').forEach((button) => {
      button.setAttribute('aria-selected', 'false');
    });

    // Set current generation selection
    event.target.setAttribute('aria-selected', 'true');

    this.elements.generationButton.querySelector('span').textContent = selectedGeneration;
    this.hidePanel('generation');

    // console.log('Selected generation:', selectedGeneration);

    // Dispatch a custom event for generation selection
    this.dispatchEvent(
      new CustomEvent('generationSelected', {
        bubbles: true,
        detail: {
          generation: selectedGeneration,
        },
      })
    );
  }

  handleize(str) {
    return str
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-$/, '')
      .replace(/^-/, '');
  }

  onModelSelect(event) {
    const button = event.currentTarget;
    const selectedSize = button.getAttribute('data-vehicle-size');

    // Find and select the matching size radio button
    const sizeRadioButton = document.querySelector(`input[name^="Size"][value="${selectedSize}"]`);
    if (sizeRadioButton) {
      sizeRadioButton.checked = true;
    } else {
      console.error('Matching variant radio button not found');
    }
  }
}

customElements.define('vehicle-model-selector', VehicleModelSelector);
